import { HttpResult } from 'widgets-for-react'
import { ArticlePage } from '../cmsPage/cmsPageState'
import { transformArticlePageData } from '../cmsPage/sharepointPageApi/transformers/pageDataToPage'
import {
  ArticlePageData,
  PageResult
} from '../cmsPage/sharepointPageApi/types/pageData'

export const featuredArticlesApi = async (): Promise<HttpResult<
  ArticlePage[]
>> => {
  const res = await fetch(`/api/v1/pages/articles/featured`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: ArticlePageData[] | null = await res.json()
  if (data === null)
    return {
      kind: 'failed',
      status: res.status
    }

  return {
    kind: 'result',
    status: 200,
    value: data.map(x => transformArticlePageData(x))
  }
}

export const semiFeaturedArticlesApi = async (): Promise<HttpResult<
  ArticlePage[]
>> => {
  const res = await fetch(`/api/v1/pages/articles/semi-featured`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: ArticlePageData[] | null = await res.json()
  if (data === null)
    return {
      kind: 'failed',
      status: res.status
    }

  return {
    kind: 'result',
    status: 200,
    value: data.map(x => transformArticlePageData(x))
  }
}

export const allPaginatedArticlesApi = async (
  page: number
): Promise<HttpResult<PageResult<ArticlePage>>> => {
  const res = await fetch(`/api/v1/pages/articles/all?page=${page}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: PageResult<ArticlePageData> = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: {
      ...data,
      Resources: data.Resources.map(x => ({
        Highlight: x.Highlight,
        Resource: transformArticlePageData(x.Resource)
      }))
    }
  }
}
